import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [sites, setSites] = useState([]);
  const [mySites, setMySites] = useState([]);
  const [rolesCatalog, setRolesCatalog] = useState([]);
  const [selectedSite, setSelectedSite] = useState(localStorage.getItem("fjc_selected_site") || "TOUS");
  const [tourOpen, setTourOpen] = useState(false);

  const refresh = useCallback(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(false));
  }, []);

  const refreshRolesCatalog = useCallback(() => {
    api.get("/roles").then(({ data }) => setRolesCatalog(data || []));
  }, []);

  useEffect(() => {
    // Skip check while AuthCallback exchanges the Google session_id
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!user) return;
    api.get("/sites").then(({ data }) => {
      setSites(data.sites || []);
      const ownSites = data.my_sites || [];
      setMySites(ownSites);
      if (!data.is_admin) {
        if (ownSites.length > 1) {
          const stored = localStorage.getItem("fjc_selected_site");
          setSelectedSite(stored && ownSites.includes(stored) ? stored : "TOUS");
        } else {
          setSelectedSite(data.my_site);
        }
      }
    });
    refreshRolesCatalog();
    if (!localStorage.getItem(`fjc_tutorial_seen_${user.Utilisateur_ID}`)) {
      setTourOpen(true);
    }
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const changeSelectedSite = (site) => {
    setSelectedSite(site);
    localStorage.setItem("fjc_selected_site", site);
  };

  const openTour = () => setTourOpen(true);
  const closeTour = () => {
    if (user) localStorage.setItem(`fjc_tutorial_seen_${user.Utilisateur_ID}`, "1");
    setTourOpen(false);
  };

  const exchangeGoogleSession = async (sessionId) => {
    const { data } = await api.post("/auth/google-session", { session_id: sessionId });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{
      user, exchangeGoogleSession, logout, refresh, sites, mySites, rolesCatalog, refreshRolesCatalog,
      selectedSite, setSelectedSite: changeSelectedSite, tourOpen, openTour, closeTour,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
